export default __webpack_public_path__ + "static/assets/3e8f5428cc874dec097c127eb482526c.png";